module.exports = __webpack_public_path__ + "img/pushpin.90d3abf2.svg";